import {
  ApiResponse,
  ClinicGroupUser,
  PaginationResponse,
} from '@magnetar/admin-api-interfaces'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'

interface UseClinicGroupUsersParams {
  page?: number
  pageSize?: number
  clinic_group_id?: number
  account?: string
}

export function useClinicGroupUsers({
  page = 1,
  pageSize = 10,
  clinic_group_id,
  account,
}: UseClinicGroupUsersParams = {}) {
  const { token } = useAuth()
  const { data, error, mutate } = useGet<ApiResponse<PaginationResponse<ClinicGroupUser>>>(
    token && clinic_group_id
      ? `/api/clinic-group-users?page=${page}&pageSize=${pageSize}&clinic_group_id=${clinic_group_id}${
          account ? `&account=${account}` : ''
        }`
      : null,
    undefined,
    token ?? '',
  )

  return {
    clinicGroupUsers: data?.data?.items,
    pagination: data?.data
      ? {
          page: data.data.page,
          pageSize: data.data.pageSize,
          total: data.data.total,
          totalPages: data.data.totalPages,
        }
      : undefined,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
